import {checkCircleFilledSvg as Icon__small__checkCircleFilledSvg} from '../Icon__small/Icon__small--checkCircleFilled.js';

export var checkCircleFilled = {
  name: 'checkCircleFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__checkCircleFilledSvg,
};
